<template>
  <v-form ref="form" lazy-validation @submit.prevent="changePassword">
    <h2 class="headline pb-2">Change Password</h2>
    <v-text-field
      v-model="user.username"
      class="max-width-400"
      type="text"
      label="Username"
      :rules="requiredRule"
    />
    <v-text-field
      v-model="user.password"
      class="max-width-400"
      type="password"
      label="Current Password"
      :rules="requiredRule"
    />
    <v-text-field
      v-model="user.newPassword"
      class="max-width-400"
      type="password"
      label="New Password"
      :rules="requiredRule"
    />
    <v-text-field
      v-model="confirmPassword"
      class="max-width-400"
      type="password"
      label="Confirm New Password"
      :rules="confirmPasswordRules"
    />
    <v-alert v-if="errorMessage" type="error" class="max-width-400">{{
      errorMessage
    }}</v-alert>
    <v-alert v-if="successMessage" type="success" class="max-width-400">{{
      successMessage
    }}</v-alert>
    <v-btn
      :disabled="!validForm"
      :loading="submitting"
      type="submit"
      color="primary"
    >
      Submit
    </v-btn>
    <v-btn type="reset" @click="reset"> Reset </v-btn>
  </v-form>
</template>

<script>
import _ from "lodash";

export default {
  name: "Login",
  data() {
    return {
      user: {
        username: "",
        password: "",
        newPassword: ""
      },
      confirmPassword: "",
      submitting: false,
      errorMessage: "",
      successMessage: "",
      requiredRule: [v => !!v || "Required"],
      confirmPasswordRules: [
        v => !!v || "Required",
        v => {
          return (
            _.isEqual(v, this.user.newPassword) || "New Passwords Must Match"
          );
        }
      ]
    };
  },
  computed: {
    validForm() {
      let { username, password, newPassword } = this.user;
      if (
        username &&
        password &&
        _.isEqual(newPassword, this.confirmPassword) &&
        newPassword
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    async changePassword() {
      this.errorMessage = "";
      this.successMessage = "";
      this.submitting = true;
      try {
        await this.$store.dispatch("changePassword", this.user);
        this.successMessage = "Password changed successfully.";
        this.reset();
      } catch (err) {
        this.errorMessage =
          (err.response && err.response.data && err.response.data.message) ||
          "Current password is incorrect.";
      } finally {
        this.submitting = false;
      }
    },
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped lang="less">
.max-width-400 {
  max-width: 400px;
}
</style>
